module.exports = __webpack_public_path__ + "static/img/app-ltd.4adf6cf8.png";